import { datadogRum } from '@datadog/browser-rum';

import {
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_RUM_SAMPLE_RATE,
  LOOM_VERSION,
  NODE_ENV,
} from 'constants/runtimeConfig';

export function init(optionsOverride = {}) {
  if (!DATADOG_RUM_APPLICATION_ID || !DATADOG_RUM_CLIENT_TOKEN) {
    return;
  }

  datadogRum.init({
    applicationId: DATADOG_RUM_APPLICATION_ID,
    clientToken: DATADOG_RUM_CLIENT_TOKEN,
    site: 'datadoghq.com',
    env: NODE_ENV,
    version: LOOM_VERSION,
    sampleRate: parseInt(DATADOG_RUM_SAMPLE_RATE, 10),
    trackInteractions: true,
    ...optionsOverride,
  });
}
